import * as z from "zod";

/** A PR's first Proof run in this session (AssistantSessionSerializer::proofCardSeats). */
export type ProofCardSeat = z.infer<typeof ProofCardSeat>;
export const ProofCardSeat = z.object({
  pr_url: z.string(),
  run_id: z.string(),
  child_session_id: z.string(),
  started_at: z.string(),
});

/**
 * A card row (see seatTranscriptCards): a PR's card, drawing its Proof too
 * when `proof_child` is set, or its Proof card. `calls` are the tool calls the
 * card stands for, which draw nothing.
 */
export type TranscriptCard = z.infer<typeof TranscriptCard>;
export const TranscriptCard = z.discriminatedUnion("kind", [
  z.object({
    kind: z.literal("pr"),
    /** `o/r#1`, see prKey. */
    pr: z.string(),
    proof_child: z.string().nullable(),
    calls: z.array(z.string()),
  }),
  z.object({
    kind: z.literal("proof"),
    pr: z.string(),
    /** The child whose first run seated the card. */
    proof_child: z.string(),
    calls: z.array(z.string()),
  }),
]);

const cardByRaw = new WeakMap<object, TranscriptCard | null>();

export function transcriptCard(message: {
  metadata?: Record<string, unknown> | null;
}): TranscriptCard | null {
  const raw = message.metadata?.transcript_card;
  if (typeof raw !== "object" || raw === null) return null;
  let card = cardByRaw.get(raw);
  if (card === undefined) {
    card = TranscriptCard.safeParse(raw).data ?? null;
    cardByRaw.set(raw, card);
  }
  return card;
}

/** Display-only row, not a turn of this session: working-state and turn-anchoring scans skip it. */
export function isTranscriptCardRow(message: {
  metadata?: Record<string, unknown> | null;
}): boolean {
  return transcriptCard(message) !== null;
}
